import { render } from "./MobileVerification.vue?vue&type=template&id=40583e52"
import script from "./MobileVerification.vue?vue&type=script&lang=js"
export * from "./MobileVerification.vue?vue&type=script&lang=js"

import exportComponent from "/media/ehsan/projects/Projects/iranget-v9/vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__